export default __webpack_public_path__ + "static/media/locationMarker.2196e37e.svg";